import { defineStore } from "pinia";
import { ref } from "vue";
import { ChoiceApi } from "../../LibMain";
import { IDocumentListItem } from "../../ChoiceScreens/Surescripts/Models/IDocumentListItem";

export const useSurescriptsRecordLocatorStore = defineStore('SurescriptsRecordLocatorStore', () => { 
    const documentsList = ref<IDocumentListItem[]>();
    const cachedDocumentsDateUTC = ref<Date>();
    const cachedDocumentsByUrl = ref<Record<string, string>>({});
    const cachedDocumentResourceResponseBlobs = ref<Record<string, Blob>>({});

    function updateDocuments(newDocumentsList: IDocumentListItem[]|undefined, documentListFetchedOnDateTimeUTC: Date)
    {
        documentsList.value = newDocumentsList ?? [];
        cachedDocumentsDateUTC.value = documentListFetchedOnDateTimeUTC;
    }

    function clearDocumentList()
    {
        documentsList.value = undefined;
        cachedDocumentsDateUTC.value = undefined;
    }

    // Get the Base64 data for the specified document based on its URL
    async function getDocumentBase64(urlSuffix: string): Promise<string|undefined>
    {
        if (undefined === cachedDocumentsByUrl.value[urlSuffix])
        {
            const docBase64 = await ChoiceApi.surescriptsRLE.getDocumentBase64(urlSuffix);
            if (!docBase64)
                return;

            cachedDocumentsByUrl.value[urlSuffix] = docBase64;
        }
        return cachedDocumentsByUrl.value[urlSuffix];
    }

    // Get the document as an web resource response
    async function getDocumentResourceResponseBlob(documentUrlSuffix: string, patientId: number): Promise<Blob|undefined>
    {
        if (undefined === cachedDocumentResourceResponseBlobs.value[documentUrlSuffix])
        {
            const resp = await ChoiceApi.surescriptsRLE.getDocumentAsResource(documentUrlSuffix, patientId);
            const isValidResp = await ChoiceApi.validApiCall(resp);
            if (!isValidResp)
            {
                // Don't cache unsuccessful responses
                return;
            }
            cachedDocumentResourceResponseBlobs.value[documentUrlSuffix] = await resp.blob();
        }
        return cachedDocumentResourceResponseBlobs.value[documentUrlSuffix];
    }

    return {documentsList, cachedDocumentsDateUTC, updateDocuments, clearDocumentList, getDocumentBase64, getDocumentResourceResponseBlob };
});